import React from "react";
import { Link } from "react-router-dom";
import { Bike, ArrowLeft, Home as HomeIcon, Wrench, MapPin } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="page-404" className="relative overflow-hidden">
      <div className="pointer-events-none absolute -top-32 left-1/2 h-[500px] w-[90%] -translate-x-1/2 rounded-full bg-sun-200/60 blur-3xl" />

      <section className="relative mx-auto flex min-h-[70vh] max-w-4xl flex-col items-center justify-center px-4 py-20 text-center sm:px-8">
        <div className="group relative">
          <span className="font-display text-[10rem] font-black leading-none tracking-tighter text-leaf-600 sm:text-[14rem]">
            4<span className="inline-block align-middle">
              <span className="inline-flex h-[8rem] w-[8rem] items-center justify-center rounded-full bg-sun-300 sm:h-[11rem] sm:w-[11rem]">
                <Bike className="spin-wheel h-20 w-20 text-leaf-900 sm:h-28 sm:w-28" />
              </span>
            </span>4
          </span>
        </div>

        <p className="mt-2 text-sm font-black uppercase tracking-[0.22em] text-leaf-700">
          Off the trail
        </p>
        <h1 className="mt-3 font-display text-4xl font-black leading-tight tracking-tight text-leaf-900 sm:text-6xl">
          Looks like you took a <span className="italic text-leaf-600">wrong turn.</span>
        </h1>
        <p className="mt-5 max-w-xl text-lg text-leaf-900/75">
          The page you're looking for doesn't exist — or maybe it rolled off
          into the sunset. Let's get you back on the path.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            data-testid="nf-cta-home"
            className="inline-flex items-center gap-2 rounded-full bg-leaf-600 px-6 py-3.5 text-sm font-bold text-white transition-all hover:-translate-y-0.5 hover:bg-leaf-700 hover:shadow-lg"
          >
            <ArrowLeft className="h-4 w-4" /> Back to home
          </Link>
          <Link
            to="/repairs"
            data-testid="nf-cta-repairs"
            className="inline-flex items-center gap-2 rounded-full border-2 border-leaf-900 bg-transparent px-6 py-3.5 text-sm font-bold text-leaf-900 transition-all hover:-translate-y-0.5 hover:bg-leaf-900 hover:text-white"
          >
            <Wrench className="h-4 w-4" /> See repairs
          </Link>
        </div>

        <div className="mt-12 grid w-full max-w-md gap-3 sm:max-w-2xl sm:grid-cols-3">
          {[
            { to: "/", icon: HomeIcon, label: "Home", testid: "nf-link-home" },
            { to: "/services", icon: Bike, label: "Services", testid: "nf-link-services" },
            { to: "/contact", icon: MapPin, label: "Contact", testid: "nf-link-contact" },
          ].map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className="group flex items-center justify-center gap-2 rounded-2xl border-2 border-leaf-100 bg-white px-4 py-3 text-sm font-bold text-leaf-900 transition-all hover:-translate-y-0.5 hover:border-leaf-300 hover:shadow-md"
            >
              <l.icon className="h-4 w-4 text-leaf-600" /> {l.label}
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
